<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>CTQ Registry</h2>
    </div>
  </div>
  <div class="wrapper wrapper-content animated fadeInRight px-0">
        <!-- FILTER -->
        <div class="ibox-content mb-1 px-3 py-2">
            <div class="form-group row my-0 d-flex align-items-end">
              <!-- CTQ ID -->
              <div class="col-12 col-lg-3 px-1">
                <label class="mb-0">CTQ ID</label>
                <input type="text" v-model="searchField.ctqId" class="form-control" placeholder="CTQ ID"
                  @keyup.enter="searchReports" />
              </div>

              <!-- Category -->
              <div class="col-12 col-lg-4 px-1">
                <label class="mb-0">Category</label>
                <input type="text" v-model="searchField.category" class="form-control" placeholder="Category"
                  @keyup.enter="searchReports" />
              </div>

              <!-- Priority -->
              <div class="col-12 col-lg-4 px-1">
                <label class="mb-0">Priority</label>
                <input type="text" v-model="searchField.priority" class="form-control" placeholder="Priority"
                  @keyup.enter="searchReports" />
              </div>

              <!-- Search Button -->
              <div class="col-12 col-lg-1 px-1">
                <span class="save_btn w-100 d-inline-block text-center" @click="searchReports">
                  Search
                </span>
              </div>
            </div>
        </div>

        <!-- TABLE -->
        <div class="ibox-body">
          <div class="ibox-title style_2 d-flex align-items-center justify-content-between">
            <h5 class="mt-0">CTQ Registry List</h5>

          <div class="d-flex align-items-center">
            <div v-if="selectedItems.size > 0" class="position-relative align-self-center mr-2"
              aria-label="Approve selected" tabindex="0">
              <img width="17" height="17" class="cursor-pointer" src="../../assets/img/approve_selected.png"
                alt="Approve selected" @click="bulkApprove()" />
              <div class="tool-tip">Approve Selected</div>
            </div>
            <div v-if="selectedItems.size > 0" class="position-relative align-self-center mr-2"
            aria-label="Reject selected" tabindex="0">
            <img width="17" height="17" class="cursor-pointer" src="../../assets/img/remove_selected.png"
              alt="Reject selected" @click="bulkReject()" />
            <div class="tool-tip">Reject Selected</div>
          </div>
            <div v-if="selectedItems.size > 0" class="position-relative align-self-center mr-2"
              aria-label="Remove selected" tabindex="0">
              <img width="17" height="17" class="cursor-pointer" src="../../assets/img/reject_selected.png"
                alt="Remove selected" @click="bulkRemove()" />
              <div class="tool-tip">Remove Selected</div>
            </div>
            <div class="position-relative cursor-pointer me-2 export-icon-wrapper" v-if="rollsprivilages.includes('CTQ Registry Upload')">
              <input type="file" ref="ctqUpload" accept=".xlsx,.xls,.csv" style="display: none"
                @change="uploadCtqFile" />
              <span @click="$refs.ctqUpload.click()">
                <img width="17" height="17" src="../../assets/img/upload.png" alt="Upload" />
              </span>
              <div class="tool-tip">Upload CTQ</div>
            </div>
            <div v-if="rollsprivilages.includes('CTQ Registry Add')" class="position-relative cursor-pointer me-2 export-icon-wrapper">
              <img class="cursor-pointer" src="@/assets/img/create.png" width="17" height="17" alt="Create CTQ"
                @click="openCreateThreshold" />
              <div class="tool-tip">Create CTQ</div>
            </div>
          </div>
        </div>

          <div class="ibox-content p-1">
            <!-- LOADER -->
            <div class="text-center" v-if="loading">
              <img src="../../assets/img/loading.gif" width="15" />
              <div>Please wait while the list is being loaded</div>
            </div>

            <!-- NO DATA -->
            <div class="text-center" v-else-if="!reportList.length">
              No data available
            </div>

            <div v-else>
              <!-- TABLE -->
              <div class="table-responsive custom-dark-table-wrapper table-scroll">
                <table class="table table-striped dark-table-head mb-0 fixed-column-table">
                  <thead>
                    <tr>
                      <!-- Select -->
                      <th class="text-center" style="width: 60px;">
                        <div class="d-flex flex-row align-items-center">
                          <span>Select</span>
                          <input type="checkbox" class="ml-2" title="Select all" :checked="isAllSelected"
                            @change="toggleSelectAll($event)" />
                        </div>
                      </th>

                      <th class="sort_block" @click="sortSelected('CTQID')">
                        <div class="d-flex justify-content-between">
                          CTQ ID
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <th class="sort_block" @click="sortSelected('category')">
                        <div class="d-flex justify-content-between">
                          Category
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <th class="sort_block" @click="sortSelected('ctqDescription')">
                        <div class="d-flex justify-content-between">
                          Description
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <th class="sort_block" @click="sortSelected('priority')">
                        <div class="d-flex justify-content-between">
                          Priority
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <th class="sort_block" @click="sortSelected('isActive')">
                        <div class="d-flex justify-content-between">
                          Status
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <th class="sort_block" @click="sortSelected('approvedByEmail')">
                        <div class="d-flex justify-content-between">
                          Approved By
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <th class="sort_block" @click="sortSelected('approvedDate')">
                        <div class="d-flex justify-content-between">
                          Approved Date
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                      <th class="sort_block" @click="sortSelected('status')">
                        <div class="d-flex justify-content-between">
                          Approval Status
                          <span>
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </div>
                      </th>

                    <!-- Sticky action columns -->
                    <th v-if="rollsprivilages.includes('CTQ Registry Actions')" class="text-center">{{ $t("navigations.actions") }}</th>
                    <th class="text-center">QTL</th>
                    <th class="text-center">Risks</th>
                    <th  v-if="rollsprivilages.includes('CTQ Registry Edit')" class="text-center">Edit</th>
                    <th class="text-center">View</th>
                  </tr>
                </thead>

                  <tbody>
                    <tr v-for="item in reportList" :key="item.id">
                      <td class="text-center">
                        <input type="checkbox" :checked="selectedItems.has(item.id)"
                          :disabled="isFinalized(item.approvals?.[0]?.status)" :title="isFinalized(item.approvals?.[0]?.status)
                              ? 'Cannot select — status is ' + item.approvals?.[0]?.status
                              : ''
                            " @change="toggleSelection(item.id)" />
                      </td>

                    <td>{{ item.ctqid }}</td>
                    <td>{{ item.category }}</td>
                   <td style="max-width: 200px; white-space: normal; word-break: break-word;">
                      <span>{{ expandedRows.has(item.id) ? item.ctqDescription : (item.ctqDescription || '').slice(0,
                        60) }}</span>
                      <span v-if="(item.ctqDescription || '').length > 60">
                        <span v-if="!expandedRows.has(item.id)">... </span>
                        <a class="more-less-link" @click.stop="toggleExpand(item.id)">
                          {{ expandedRows.has(item.id) ? 'less' : 'more' }}
                        </a>
                      </span>
                    </td>
                    <td>{{ item.priority }}</td>
                    <td>{{ item.isActive ? "Active" : "Inactive" }}</td>
                    <td>{{ item.approvals?.[0]?.approvedByEmail }}</td>
                    <td>{{ filter(item.approvals?.[0]?.approvedDate) }}</td>
                    <td>{{ item.approvals?.[0]?.status }}</td>

                      <!-- Approve / Reject -->
                      <td v-if="rollsprivilages.includes('CTQ Registry Actions')" class="text-center">
                        <i v-if="!isFinalized(item.approvals?.[0]?.status)" class="fa fa-check-circle edit-delete"
                          title="Approve / Reject" @click="openApproveRejectPopup(item)"></i>
                        <span v-else class="text-muted small" :title="item.approvals?.[0]?.status"></span>
                      </td>

                    <!-- QTL -->
                    <td class="text-center">
                      <i class="fa fa-eye edit-delete" title="View QTL" @click="viewQTL(item)"></i>
                    </td>
                    <!-- Risks -->
                    <td class="text-center">
                       <i class="fa fa-eye edit-delete" title="View Risks" @click="viewRisks(item)"></i>
                    </td>
                    <!-- Edit -->
                    <td  v-if="rollsprivilages.includes('CTQ Registry Edit')" class="text-center">
                      <i class="fa fa-edit edit-delete" title="Edit CTQ" @click="openEditCtq(item)"></i>
                    </td>

                      <!-- View -->
                      <td class="text-center">
                        <i class="fa fa-eye edit-delete" title="View Details" @click="viewDetails(item)"></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- PAGINATION -->
              <div class="row mt-3" v-if="totalPages > 1">
                <div class="col-12 d-flex justify-content-end">
                  <VPagination v-model="currentPage" :pages="totalPages" :range-size="1" active-color="#618bd7"
                    @update:modelValue="getReportList" />
                </div>
              </div>
            </div>
          </div>
        </div>
  </div>
  <viewCtqRegistryModal v-if="showViewModal" :data="selectedCtq" @closeModal="closeViewModal" />

  <mitigationInfoModal v-if="showMitigationModal" :data="selectedCtqForMitigation"
    @closeModal="closeMitigationModal" />

  <approveRejectModal v-if="showApproveRejectPopup" heading="Approve/Reject CTQ" action1Label="Approve"
    action2Label="Reject" httpMethod="put" :apiUrl="approveApiEndpoint" :payload="selectedCtqPayload" statusKey="status"
    commentsKey="comments" successMsgApprove="CTQ approved successfully." successMsgReject="CTQ rejected successfully."
    fromPage="CtqRegistry" @closePopup="showApproveRejectPopup = false" @actionSuccess="onApproveRejectSuccess" />

  <CtqAddEditModal v-if="showCtqModal" :data="selectedCtqData" @closeModal="closeCtqModal" @saveCtq="onSaveCtq" />
  <RiskListModal v-if="showRiskListModal" :data="selectedCtqForRiskList" @closeModal="closeRiskListModal" />
  <QtlInfoModal v-if="showQTLModal" :data="selectedCtqForQTL" @closeModal="closeQTLModal" />
</template>

<script src="./CtqRegistry.js"></script>

<style scoped>
.ibox-title{
    padding: 2px 15px 8px 15px;
    min-height: 36px;
}
.table-scroll {
  max-height: 350px;
  overflow-y: auto;
}

.custom-dark-table-wrapper {
  max-height: 400px;
  overflow-x: auto;
  overflow-y: auto;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  vertical-align: middle;
  border-color: #dee2e6;
}

.dark-table-head>thead {
  --bs-table-accent-bg: hsl(205, 72%, 37%) !important;
  color: #ffffff !important;
}

.fixed-column-table {
  --col-width: 45px;
  width: max-content;
  min-width: 100%;
}

.fixed-column-table th,
.fixed-column-table td {
  padding: 4px 14px;
  white-space: nowrap;
  background: #ffffff;
}

.fixed-column-table thead th {
  position: sticky;
  top: 0;
  z-index: 4;
  background: #0b578d;
  color: #fff;
}

/* Sticky last 4 columns: View, Edit, Mitigation, Actions */
.fixed-column-table th:last-child,
.fixed-column-table td:last-child {
  position: sticky;
  right: 0;
  z-index: 3;
  width: var(--col-width);
  min-width: var(--col-width);
}

.fixed-column-table th:nth-last-child(2),
.fixed-column-table td:nth-last-child(2) {
  position: sticky;
  right: var(--col-width);
  z-index: 3;
  width: var(--col-width);
  min-width: var(--col-width);
}

.fixed-column-table th:nth-last-child(3),
.fixed-column-table td:nth-last-child(3) {
  position: sticky;
  right: calc(var(--col-width) * 2);
  z-index: 3;
  width: var(--col-width);
  min-width: var(--col-width);
}

.fixed-column-table th:nth-last-child(4),
.fixed-column-table td:nth-last-child(4) {
  position: sticky;
  right: calc(var(--col-width) * 3);
  z-index: 3;
  width: var(--col-width);
  min-width: var(--col-width);
}

/* Keep sticky header cells above body cells */
.fixed-column-table thead th:last-child,
.fixed-column-table thead th:nth-last-child(2),
.fixed-column-table thead th:nth-last-child(3),
.fixed-column-table thead th:nth-last-child(4) {
  z-index: 5;
}

.form-select {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sort_block {
  cursor: pointer;
}
.more-less-link {
  color: #618bd7 !important;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 500;
  user-select: none;
}
</style>